import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  access_token: localStorage.getItem('access_token') || null,
  user: JSON.parse(localStorage.getItem('userInfo')) || null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.access_token = action.payload.access_token;
      state.user = action.payload.user;

      localStorage.setItem('access_token', action.payload.access_token);
      localStorage.setItem('userInfo', JSON.stringify(action.payload.user));
    },
    logout: (state) => {
      state.access_token = null;
      state.user = null;
      localStorage.removeItem('access_token');
      localStorage.removeItem('userInfo');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;